import { useMutation } from "@tanstack/react-query";
import { ILogsApi } from "@/api/logs";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { LogsQueryParams } from "@/models/logs";
import { useToast } from "@/hooks/use-toast";

export const useLogs = () => {
  const logsApi = useInjection<ILogsApi>(SERVICES_TYPES.LOGS);
  const { toast } = useToast();
  return useMutation({
    mutationFn: (params: LogsQueryParams) => logsApi.getLogs(params),
    onError: (error) => {
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive"
      });
    }
  });
};
